import HttpFactory from 'http-service-v3'

export default function accountFactory() {
    const http = HttpFactory()

    return {
      /*
      invite json:
      * InviteExpiryInDays: Value from 1 to 14 days
      */
      initInviteObject() {
        return {
          FirstName: '',
          LastName: '',
          Email: '',
          InviteExpiryInDays: 7
        }
      },
      requestInviteObject(inviteID) {
        return http
          .get(http.wsaDomain + `/account/v2/accounts/requestinviteobject/${inviteID}`)
          .then(response => { return response.data })
      },
      cancelInviteByUser(inviteID) {
        return http
          .delete(http.wsaDomain + `/account/v2/accounts/cancelinvitebyuser/${inviteID}`)
      },
      resendInviteByUser(email) {
        return http
          .get(http.wsaDomain + `/account/v2/accounts/resendinvitebyuser/${email}`)
          .then(response => { return response.data })
      },
      isInvited(email) {
        return http
          .get(http.wsaDomain + `/account/v2/accounts/isinvited/${email}`)
          .then(response => { return response.data })
      },
      checkDomainExists(email) {
        return http
          .get(http.wsaDomain + `/account/v2/checkdomainexists/${email}`)
          .then(response => { return response.data })
      },
    }
  }